// extracted by mini-css-extract-plugin
export default {"infoList":"styles_infoList__3CsSA","infoItem":"styles_infoItem__TJEyW"};